import { upgradeAdapter } from './upgrade_adapter';
import { enableProdMode } from '@angular/core';
// set angular to production mode if app is set
if (process.env.ENV === 'production') {
    enableProdMode();
}

const version = require('../version.txt');
window.version = version;

// Default modules & sub modules
const modules = [
    'ngCookies',
    'ngResource',
    'ui.bootstrap',
    'ui.router',
    'rp.system',
    'rp.pages',
    'rp.auth',
    'rp.landing',
    'rp.changelog',

];
angular.module('rp', modules);

// system
// call file-upload shim
var systemModule = angular.module('rp.system', []);

// pages
var pagesModule = angular.module('rp.pages', [
    'ngDialog',
    'angularSpinner',
    'ng-sortable'
]);

// auth
var authModule = angular.module('rp.auth', []);

// landing
var landingModule = angular.module('rp.landing', []);

var changelogModule = angular.module('rp.changelog', []);

// load child components
require('./system')(systemModule);
require('./pages')(pagesModule);
require('./auth')(authModule);
require('./landing')(landingModule);
require('./changelog')(changelogModule);

angular.element(document).ready(function () {
    //Then init the app
    upgradeAdapter.bootstrap(document.body, ['rp'], { strictDi: true });
});



/** WEBPACK FOOTER **
 ** ./src/init.js
 **/